/**
 * A global namespace for `unload` event.
 */
const unloadEvent = 'unload';
export default unloadEvent;
